export default __webpack_public_path__ + "static/media/full_arrow_left.3fff898a.svg";